import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { LoadAnalytics } from '../states/analytics/analytics.actions';
import { mapRouteParamsToAnalyticsFilters } from '@app/utils/incidents/incidents.utils';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsResolver implements Resolve<boolean> {
  constructor(private store: Store) {}

  async resolve(route: ActivatedRouteSnapshot): Promise<boolean> {
    const { filters } = mapRouteParamsToAnalyticsFilters(route.queryParams);

    this.store.dispatch(new LoadAnalytics({ filters }));

    return true;
  }
}
